export const registrationSteps = ["Crea tu cuenta", "Crea tu mesa de regalos"];
